import { Injectable } from '@angular/core';
import { isDevelopmentEnvironment, isProductionEnvironment, isStagingEnvironment } from '@howdeniberia/core-front';
import { FRONT_PATH_APPS } from 'src/app/core/constants/front-path-app-constants';
import { ApiConfigurations } from 'src/environments/api-configurations';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ElectronicSignatureService {
  private readonly apiInfo = ApiConfigurations.find(api => api.name === FRONT_PATH_APPS.FRONT_ELECTRONIC_SIGNATURE);

  getElectronicSignatureUrl(projectId: number): string {
    let baseUrl = this.apiInfo?.paths.local || '';;
    if (isProductionEnvironment(environment.zone)) {
      baseUrl = this.apiInfo?.paths.production || '';
    } else if (isStagingEnvironment(environment.zone)) {
      baseUrl = this.apiInfo?.paths.staging || '';
    } else if (isDevelopmentEnvironment(environment.zone)) {
      baseUrl = this.apiInfo?.paths.development || '';
    }
    return `${baseUrl}/signature-project/${projectId}`;
  }
}
